<template>
  <div id="fullpage">
    <!-- Map Area Starts -->
    <section class="map-area section-padding hezuo_section1 section" >
      <div class="banner-sun">
          <p class="p1 animate fadeInDown animated jjfangan_zt1" style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">合作伙伴</p>
  		  <p class="p2 animate zoomIn animated jjfangan_zt2" style="animation-duration: 1s; animation-delay: 1s; visibility: visible;  color: #E91E63;">PARTNERS</p>
  		  <!-- <P class="p3 animate fadeInUp animated jjfangan_zt3" style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
      </div>
  	  <div class="animate bounce animated" style="width: 100%; height: 100px; line-height: 100px; text-align: center;animation-duration: 1s; animation-delay: 1s; visibility: visible;">
  		  <img src="/static/assets/images/shubiao.png"/>
  	  </div>
    </section>
	<!-- Map Area End -->
	<!-- 合作伙伴 starts -->
	
	<section class="section-padding8 section">
		<div class="container">
			<div class="donghuasun hezuokuandu" style="width: 100%;padding-top:2%; text-align: center;animation-duration: 1s; animation-delay: 0.3s;">
					  <p style="    font-size: 30px; color: #44BCB9;">PARTNERS</p>
					  <p style="font-size: 24px; color: #666666;">商务合作伙伴</p>
			</div>
			<div class="tablea slider">
				<!-- <div class="xintablea" v-for="(item,index) in huobanlist" :key="index">
					<a :href="item.apilink" target="_blank"> <img :src="newurl + item['ico']"  class="donghuasunfadeIn" style="animation-duration: 1s; animation-delay: 0.6s;"/></a>
				</div> -->

				<div class="slider-container">
					<div class="slide">
						<div class="shojilaoxun" style="width: 79%;  height: 100%;">
							<div class="xintablea" v-for="(item, index) in huobanlist" :key="index">
							<a :href="item.apilink" target="_blank"> <img :src="newurl + item['ico']" class="donghuasunfadeIn"
								style="animation-duration: 1s; animation-delay: 0.6s;" /></a>
							</div>
						</div>
					</div>
					<div class="slide">
						<div class="shojilaoxun" style="width: 79%;  height: 100%;">
							<div class="xintablea" v-for="(item, index) in huobanlista" :key="index">
							<a :href="item.apilink" target="_blank"> <img :src="newurl + item['ico']" class="donghuasunfadeIn"
								style="animation-duration: 1s; animation-delay: 0.6s;" /></a>
							</div>
						</div>
					</div>
				</div>
			   
			</div>


			

			
		</div>
	
	</section>
	
	<!-- 合作伙伴 end -->
	<!-- Footer Area Starts -->
	  <section class="footer-area section-padding9 section">
		<div class="footer-widget">
	      <div class="container">
	        <div class="row">

	          <div class="col-xl-5 offset-xl-1 col-lg-6">
	            <div class="single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd" style="animation-duration: 0.5s; animation-delay: 0.3s;">
	              <h3 class="mb-4 phone_weibu_zt1" style="font-weight: 500;font-size: 40px;">专业技术团队 提供全方位系统解决方案</h3>
	              <p class="mb-4" style="color: #7a7a7a;line-height: 60px;">如有任何疑问 请随时与我们联系</p>
	              <form>

	                <input type="messname"  v-model="messname" placeholder="您的姓名" onfocus="this.placeholder = ''" onblur="this.placeholder = '您的姓名'" required>
					<input type="messtel"  v-model="messtel" placeholder="您的电话" onfocus="this.placeholder = ''" onblur="this.placeholder = '您的电话'" required>
					<input type="messtitle"  v-model="messtitle" placeholder="您的留言" onfocus="this.placeholder = ''" onblur="this.placeholder = '您的留言'" required>
	                <button type="submit" class="template-btnb" @click="buttonmess" style="background: rgb(0 100 207);">立即提交</button>
	              </form>
	            </div>
	          </div>

	        </div>
	      </div>
	    </div>
	    <div class="footer-copyright weibu_sun">
	      <div class="container  weibu912" style="padding-top: 50px;">
	        <div class="weibu_a donghuasun" style="animation-duration: 0.6s; animation-delay: 0.3s;">
				<img src="/static/assets/images/logob.png"/>
				<div class="image-counter">
					<div class="image-containerc"></div>
					<div class="image-containera"></div>
					<div class="image-containerb"></div>
					<!-- <img src="/static/assets/images/weixin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/douyin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/weibo.png" style="width: 35px;height: 35px;"> -->
				</div>
			</div>
			<div class="weibu_b donghuasun"  style="animation-duration: 0.6s; animation-delay: 0.4s;">
					<p>工业物联网整体解决方案服务商</p>
					<p>智能传感解决方案专家</p>
			</div>
			<div class="weibu_c donghuasun" style="animation-duration: 0.6s; animation-delay: 0.5s;">
					<p>{{zhandianinfo.copyright}}</p>
					<p>总部公司 : {{qiyeinfo.address}}</p>
					<p>服务热线 : {{qiyeinfo.mobile}}</p>
					<p>主营产品 : {{qiyeinfo.other}}</p>
					<p>{{zhandianinfo.icp}} <i><img src="/static/assets/images/gongan.png" style="width:16px; height:16px;margin-bottom: 5px;"></i></p>
			</div>
	      </div>
	    </div>
	  </section>
	  <!-- Footer Area End -->
    
	</div>
</template>


<script>
import axios from 'axios';
export default {
  data() {
    return {
			qiyeinfo:[],
			zhandianinfo:[],
			daohanglist:[],
			messtel:'',
			messname:'',
			messtitle:'',

		huobanlist:[
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
				{
					ico:'',
					id:'',
					title:''
				},
			],
			huobanlista: [
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
      ],
			newurl:'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted(){
	//公司信息
	axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.qiyeinfo = response.data.data;
			
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});

				//站点信息
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.zhandianinfo = response.data.data;
				
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});

				  //合作伙伴2
				  axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/17/num/20/page/2/order/sorting', {
					appid: 'jurenkeji2024',
					timestamp: '1722845854',
					signature: '0eb76b812e96966c380b90c6e7416a26'
					})
					.then(response => {
						// console.log(response.data.data);
						this.huobanlista = response.data.data;
					})
					.catch(error => {
						console.error('当前网络环境异常!', error);
					});
				//导航数据
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.daohanglist = response.data.data;
				
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});
//战略合作伙伴
axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/30/num/20/order/sorting', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.huobanlist = response.data.data;
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});
  },
  methods: {
    //提交留言
	buttonmess(){
			// Message.success(`输入的内容是: ${this.messtitle}`);
			if(this.messname != '' && this.messtel != '' && this.messtitle){
				// console.log('可以继续进行');
				// console.log('输入的内容是:', this.messname);
				// console.log('输入的内容是:', this.messtel);
				// console.log('输入的内容是:', this.messtitle);
					axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
						name:this.messname,
						tel:this.messtel,
						content:this.messtitle,
					      appid: 'jurenkeji2024',
					      timestamp: '1722845854',
					      signature: '0eb76b812e96966c380b90c6e7416a26'
						})
						.then(response => {
							// console.log(response.data.data);
							// that.bannerlist = response.data.data;
							alert('留言提交成功!');
							this.messname = '';
							this.messtel = '';
							this.messtitle = '';
						})
						.catch(error => {
							console.error('当前网络环境异常!', error);
						});

			}else{
				alert('内容不能为空');
        		return;	
				// console.log('不能为空');
			}
			
		}
  }
};
</script>
<style>
.slider {
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .slider-container {
    display: grid;
    grid-template-columns: repeat(3, 100vw);
    width: 300vw;
    transition: transform 0.5s ease-in-out;
  }

  .slide {
    width: 100vw;
    height: 100vh; /* 根据需要设置高度 */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
  }
</style>






// WEBPACK FOOTER //
// PricingPlan.vue?072a8746